<template>

    <div>

        <div class="row mb-5">

            <div class="col-xl-8">

                <div class="row mb-3">
                    <div class="col">
                        <button class="btn btn-light btn-sm mb-1" @click="expandAll()">{{ t.__('Rozwiń wszystko') }}</button>
                        <button class="btn btn-light btn-sm mb-1" @click="collapseAll()">{{ t.__('Zwiń wszystko') }}</button>
                    </div>
                </div>

                <div class="marketing-resources-wrapper">
                    <div class="marketing-resources mt-1">

                        <marketing-resources-area v-for="(area, index) in library" :key="index" :area="area">
                            <template slot-scope="props">
                                <marketing-resources-package v-for="(package_, index) in area.packages" :key="index" :package_="package_" :area-expanded="props.areaExpanded">
                                    <template slot-scope="props">
                                        <marketing-resources-set v-for="(set, index) in package_.sets" :key="index" :set="set" :package-expanded="props.packageExpanded">
                                            <template slot-scope="props">
                                                <marketing-resources-game v-for="(game, index) in set.games" :key="index" :game="game" :set-expanded="props.setExpanded"></marketing-resources-game>
                                            </template>
                                        </marketing-resources-set>
                                    </template>
                                </marketing-resources-package>
                            </template>
                        </marketing-resources-area>

                    </div>
                </div>

                <marketing-resources-element-preview-modal :languages="languagesInput"></marketing-resources-element-preview-modal>

                <marketing-resources-element-translate-modal :languages="languagesInput"></marketing-resources-element-translate-modal>

                <marketing-resources-element-edit-modal :languages="languagesInput"></marketing-resources-element-edit-modal>

                <div class="my-3">
                    <div class="caption-title">{{ t.__('Legenda:') }}</div>
                    <div class="caption-color-block yellow">{{ t.__('Obszar') }}</div>
                    <div class="caption-color-block green">{{ t.__('Pakiet') }}</div>
                    <div class="caption-color-block blue">{{ t.__('Zestaw') }}</div>
                    <div class="caption-color-block white">{{ t.__('Gra') }}</div>
                </div>

            </div>

            <div class="col-xl-4 text-center">

                <div class="d-inline-block mt-5" v-if="userHasPermission('marketing_resources.marketing_resources.edit')">
                    <a href="#" class="btn btn-sm btn-block btn-primary px-4 mb-2" @click="manageSections('area')">{{ t.__('Zarządzaj sekcjami obszaru') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-dark px-4 mb-3" @click="translateSections('area')">{{ t.__('Tłumacz sekcje obszaru') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-primary px-4 mb-2" @click="manageSections('package')">{{ t.__('Zarządzaj sekcjami pakietu') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-dark px-4 mb-3" @click="translateSections('package')">{{ t.__('Tłumacz sekcje pakietu') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-primary px-4 mb-2" @click="manageSections('set')">{{ t.__('Zarządzaj sekcjami zestawu') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-dark px-4 mb-3" @click="translateSections('set')">{{ t.__('Tłumacz sekcje zestawu') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-primary px-4 mb-2" @click="manageSections('game')">{{ t.__('Zarządzaj sekcjami gry') }}</a>
                    <a href="#" class="btn btn-sm btn-block btn-dark px-4 mb-2" @click="translateSections('game')">{{ t.__('Tłumacz sekcje gry') }}</a>
                </div>

                <marketing-resources-sections-modal :base-language="baseLanguageInput"></marketing-resources-sections-modal>

                <marketing-resources-sections-translate-modal :languages="languagesInput" :base-language-input="baseLanguageInput"></marketing-resources-sections-translate-modal>

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'MarketingResources',

        props: [
            'libraryInput',
            'languagesInput',
            'baseLanguageInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                library: []
            }
        },

        computed: {

        },

        beforeMount() {

            this.library = this.libraryInput;

        },

        mounted() {


        },

        methods: {

            collapseAll() {
                this.eventHub.$emit('marketing-resources-collapse-all');
            },

            expandAll() {
                this.eventHub.$emit('marketing-resources-expand-all');
            },

            manageSections(elementType) {
                this.eventHub.$emit('marketing-resources-sections-edit', elementType);
            },

            translateSections(elementType) {
                this.eventHub.$emit('marketing-resources-sections-translate', elementType);
            }
        }

    }
</script>

<style scoped>

    .marketing-resources-wrapper {
        overflow-x: auto;
    }

    .marketing-resources {
        min-width: 660px;
        border-top: 1.5px solid #e5e5e5;
    }

    /deep/ .marketing-resources .element.top-element {
        border-left: 1.5px solid #e5e5e5;
        border-right: 1.5px solid #e5e5e5;
    }

    /deep/ .marketing-resources .element.nested-element {
        border-left: 1.5px solid #e5e5e5;
    }

    /deep/ .marketing-resources .element > .element-heading {
        display: flex;
        align-items: center;
        border-bottom: 1.5px solid #e5e5e5;
        padding-right: 130px;
    }

    /deep/ .marketing-resources .element > .element-heading .collapse-icon {
        padding: 10px 0;
        width: 40px;
        display: inline-block;
        text-align: center;
    }

    /deep/ .marketing-resources .element > .element-heading .element-name {
        display: inline-block;
        padding: 10px 10px 10px 0;
        left: -5px;
        position: relative;
    }

    /deep/ .marketing-resources .element > .element-heading .element-buttons {
        padding: 10px;
        margin-left: auto;
    }

    /deep/ .marketing-resources .element > .element-heading .element-buttons > a {
        font-size: 125%;
        position: absolute;
    }

    /deep/ .marketing-resources .element > .element-heading .element-buttons > a.preview {
        right: 25px;
        margin-top: -14px;
    }

    /deep/ .marketing-resources .element > .element-heading .element-buttons > a.translate {
        right: 52px;
        margin-top: -12px;
    }

    /deep/ .marketing-resources .element > .element-heading .element-buttons > a.edit {
        right: 76px;
        margin-top: -12px;
    }

    /deep/ .marketing-resources .element > .element-heading .element-text {
        display: inline-block;
        padding: 10px;
        position: relative;
    }

    /deep/ .marketing-resources .element.last-element > .element-heading .element-name {
        padding: 10px;
        left: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /deep/ .marketing-resources .element.last-element > .element-heading .element-name small {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /deep/ .marketing-resources .element.nested-element {
        margin-left: 40px;
    }

    /deep/ .marketing-resources .element.expanded {
        border-bottom: 1.5px solid #e5e5e5;
    }

    /deep/ .marketing-resources .element.nested-element.repo-dev:last-child > .element-heading {
        border-bottom: none;
    }

    /deep/ .marketing-resources .element.nested-element.expanded:not(.repo-dev):last-child {
        border-bottom: none;
    }

    /deep/ .marketing-resources .element.nested-element.collapsed:not(.repo-dev):last-child > .element-heading {
        border-bottom: none;
    }

    /deep/ .marketing-resources .element.nested-element.last-element:not(.repo-dev):last-child > .element-heading {
        border-bottom: none;
    }

    /deep/ .marketing-resources .yellow,
    .caption-color-block.yellow {
        background: #fdffd7;
    }

    /deep/ .marketing-resources .green,
    .caption-color-block.green {
        background: #e6ffe4;
    }

    /deep/ .marketing-resources .blue,
    .caption-color-block.blue {
        background: #ebf4ff;
    }

    /deep/ .marketing-resources .white,
    .caption-color-block.white {
        background: #ffffff;
    }

    .caption-title {
        display: inline-block;
        font-size: 0.875rem;
        padding: 4px 0px;
    }

    .caption-color-block {
        display: inline-block;
        margin-left: 5px;
        font-size: 0.875rem;
        padding: 4px 8px;
        border: 1.5px solid #e5e5e5;
    }

</style>
